import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion} from 'react-bootstrap';
import ProjetoCulturalService from '../../../../services/projetoCultural';
import { Link } from 'react-router-dom';
import '../../../../styles/diario.scss';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [patrocinador, setPatrocinador] = useState("");
    const [beneficiario, setBeneficiario] = useState("");
    const [andamento, setAndamento] = useState("");
    const [dataIn, setDataIn] = useState("");
    const [dataFt, setDataFt] = useState("");


    const busca = async (query) => {
        if (query == "") {
            await props.fetchProjetos()
            setPatrocinador("")
            setBeneficiario("")
            setAndamento("")
            setDataIn("")
            setDataFt("")
        } else {
            var response = await ProjetoCulturalService.buscar(query)
            if (response.data.length >= 1) {
                props.setProjetos(response.data)
                props.setVazio(false)
                setPatrocinador("")
                setBeneficiario("")
                setAndamento("")
                setDataIn("")
                setDataFt("")
            } else {
                props.setVazio(true)
                setPatrocinador("")
                setBeneficiario("")
                setAndamento("")
                setDataIn("")
                setDataFt("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (patrocinador) prepQuery = prepQuery + `&patrocinador=${encodeURI(patrocinador)}`;
        if (beneficiario) prepQuery = prepQuery + `&beneficiario=${encodeURI(beneficiario)}`;
        if (andamento !== "false" && andamento !== "") prepQuery = prepQuery + `&andamento=${encodeURI(andamento)}`;
        if (dataIn) prepQuery = prepQuery + `&dataIn=${dataIn}`;
        if (dataFt) prepQuery = prepQuery + `&dataFt=${dataFt}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="patrocinador">
                                <FloatingLabel
                                    label="Patrocinador/Doador"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="patrocinador"
                                        value={patrocinador}
                                        onChange={e => setPatrocinador(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="beneficiario">
                                <FloatingLabel
                                    label="Beneficiario"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="beneficiario"
                                        value={beneficiario}
                                        onChange={e => setBeneficiario(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Andamento">
                                <FloatingLabel
                                    label="Andamento"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="Andamento"
                                        name="andamento"
                                        onChange={e => setAndamento(e.target.value)}
                                    >
                                        <option>TODOS</option>
                                        <option value="Em Andamento">Em Andamento</option>
                                        <option value="Recursos Captados">Recursos Captados</option>
                                        <option value="Concluído">Concluído</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataInicial">
                                <FloatingLabel
                                    label="Data Inicial"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataIn"
                                        value={dataIn}
                                        onChange={e => setDataIn(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="dataFinal">
                                <FloatingLabel
                                    label="Data Final"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataFt"
                                        value={dataFt}
                                        onChange={e => setDataFt(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/renuncias'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                     <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.projetos} nome={"Projetos"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#1ee432f9-ea2e-4142-8d35-313265078fe1" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
